import Vue from 'vue'
import Inbox from './components/inbox.vue'

Vue.component('inbox', Inbox);

new Vue({
    el: '#Inbox',
});



// WEBPACK FOOTER //
// ./assets/vue/main.js